var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('codemirror',{ref:"editor",attrs:{"options":{
    viewportMargin: Infinity,
    theme: 'lsystem',
    mode: 'application/lsystem',
  }},model:{value:(_vm.model.code),callback:function ($$v) {_vm.$set(_vm.model, "code", $$v)},expression:"model.code"}}),(_vm.model.error)?_c('div',{staticClass:"error-container"},[_c('pre',{staticClass:"error hl"},[_vm._v(_vm._s(_vm.model.error))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }